












































import { Component, Vue, Prop, Inject } from 'vue-property-decorator';
import { User } from '@pjn/core/model/app/User';
import MenuItem from '@pjn/core/model/app/MenuItem';
import { BooleanProp, OptionalProp, EmptyProp } from '@pjn/vue-core/component';
import { AuthStore } from '@pjn/vue-core/store/AuthStore';
import { isDefined } from '../../../utils/src/general';
import { RouteSecurity, checkAccess } from '../../../core/src/security';

/**
 * Toolbar y menu de aplicacion.
 *
 * Incluye una ```<Toolbar />``` y un ```<SideMenu />``` (solo mobile).
 */
@Component
export default class AppToolbar extends Vue {

  /**
   * Titulo a mostrar en desktop (opcional).
   *
   * Si no se incluye, se muestra el titulo global de la app o
   * el nombre de la ruta actual.
   */
  @Prop() title: string;

  /** Prefijo a Mostrar antes del titulo */
  @Prop({default: 'PJN'}) preTitle: string;

  /** [Desktop] Comprime la altura (default true) */
  @BooleanProp(true) dense: boolean;

  /** [Mobile] Comprime la altura (default false) */
  @Prop({type: Boolean, default: false}) denseMobile: boolean;

  /** Extiende la altura de la Toolbar para que tenga dos niveles. */
  @OptionalProp() extended: boolean;

  /** Altura de la extension */
  @OptionalProp({type: [Number, String]}) extensionHeight: number | string;

  /** Remueve la sombra */
  @BooleanProp(false) flat: boolean;

  /** [Mobile] Muestra el boton de back en lugar del de menu lateral */
  @BooleanProp(false) showBack: boolean;

  /** Ancho del sidebar */
  @Prop({ default: 300 }) sidebarWidth: number;

  @Inject()
  private menuItems: MenuItem[];

  @Inject()
  private APP_TITLE: string;

  @Inject()
  private authStore: AuthStore;

  private get realTitle() {
    return this.title || this.APP_TITLE || this.$route.name;
  }

  private drawer = false;

  /** Items a mostrar segun el acceso del usuario */
  private get shownItems() {
    return this.menuItems.map(i => this.checkMenuItemAccess(i)).filter(isDefined);
  }

  /**
   * Comprueba si el item y sus subitems son accesibles.
   * 
   * Devuelve el item de menu con sus subitems filtrados segun la seguridad o `null` si el item no es accesible.
   */
  private checkMenuItemAccess(i: MenuItem): MenuItem | null {
    
    // Si el usuario no puede acceder al item, se devuelve null (luego se filtra)
    if(!checkAccess(this.authStore, i.auth)) return null;

    // Si tiene subitems, se llama a esta funcion recursivamente para obtener los subitems filtrados por seguridad
    const subItems = i.subItems ? i.subItems.map(si => this.checkMenuItemAccess(si)).filter(isDefined) : undefined;

    // Se devuelve el item
    return { ...i, subItems };
  }

  private get user(): User | null {
    return this.authStore ? this.authStore.user : null;
  }

  private get selected() {
    const items = this.menuItems.reduce((result: MenuItem[], item: MenuItem) => [...result, item, ...(item.subItems ? item.subItems : [])], []);
    return items.find(item => item.url === this.$route.path) || null;
  }

  private onDrawerClick() {
    this.drawer = !this.drawer;
  }

  private onBackClick() {
    this.$emit('backClick');
  }

  private onItemClick(item: MenuItem) {
    // Si tiene url, se cambia la ruta
    if (item.url) this.$router.push(item.url);
    this.$emit('itemClick', item);
  }

  private onLogin() {
    if (this.authStore) this.authStore.login();
  }

  private onLogout() {
    if (this.authStore) this.authStore.logout();
  }
}
